module.exports = __webpack_public_path__ + "static/img/content6.714465ca.png";